
// wrapper that is replaced when a filter changes
class FilterValues extends HTMLElement{

}
customElements.define("filter-values",FilterValues);
// wrapper that is replaced when filters are applied
class ProductsContainer extends HTMLElement{

}
customElements.define("products-container", ProductsContainer);

// abstract class that handles filter values
class FilterValue extends HTMLElement {

  static virtualSection = null;
  static section = null;
  static sectionId = null;
  static virtualUrl = null;
  static initialized = false;

  static updateProductContainer(){
    const oldProducts = FilterValue.section.querySelector("products-container");
    const newProducts = FilterValue.virtualSection.querySelector("products-container");
    if (!!oldProducts && !!newProducts) {
      oldProducts.replaceWith(newProducts);
      window.dispatchEvent( new CustomEvent('filter:sort-by', { detail: "date" }))
    }
  }
  static updateFilterValues(){
    const oldFilter = FilterValue.section.querySelector("filter-values");
    const newFilter = FilterValue.virtualSection.querySelector("filter-values");
    if (!!oldFilter && !!newFilter) {
      oldFilter.replaceWith(newFilter);
    }
  }
  static updateDeepLinking() {
    const currentURL = new URL(location.href);
    const newURL = new URL(FilterValue.virtualUrl, location.origin);
    // übernehme alle parameter die nichts mit dem filter zu tun haben
    currentURL.searchParams.forEach((value, key) => {
      if (!key.includes("filter")) {
        newURL.searchParams.set(key, value);
      }
    });
    history.replaceState(null, "", newURL.href);
  }

  constructor() {
    super();
  }
  get paramName(){
    return this.getAttribute('param-name') || ""
  }
  connectedCallback(){

    if(!FilterValue.initialized){
      FilterValue.section = this.closest("[section-id]")
      FilterValue.virtualSection = FilterValue.section
      FilterValue.virtualUrl = location.href

      if (!FilterValue.section) {
        return console.warn('Could not find section.')
      }
      FilterValue.sectionId = FilterValue.section.getAttribute("section-id");

      if (!FilterValue.sectionId) {
        return console.warn('Section ID or URL missing')
      }

      window.addEventListener('filter:apply', (e) => {
        console.log("receive filter:apply")
        FilterValue.updateProductContainer()
        FilterValue.updateDeepLinking();
      })

      window.addEventListener('filter:reset', async (e) => {
        console.log("receive filter:reset")
        window.sessionStorage.removeItem('_filterLocationLat')
        window.sessionStorage.removeItem('_filterLocationLon')
        window.sessionStorage.removeItem('_filterLocationValue')
        const newUrl = new URL(location)
        newUrl.search = ""
        await FilterValue.updateDOM(newUrl)
        FilterValue.updateProductContainer()
        FilterValue.updateDeepLinking();
      })

      FilterValue.initialized = true;
      window.dispatchEvent(new Event('filter:init'));
    }

  }
  async updateDOM(url){
    await FilterValue.updateDOM(url)
  }
  static async updateDOM(url) {
    FilterValue.virtualUrl = url;


    const fetchUrl = new URL(url, location.origin);
    fetchUrl.searchParams.set("section_id", FilterValue.sectionId);

    await fetch(fetchUrl.href, {
      method: "GET",
    })
    .then((response) => response.text())
    .then((data) => {
      const template = document.createElement('template')
      template.innerHTML = data.trim();
      FilterValue.virtualSection = template.content;

      FilterValue.updateFilterValues()
      window.dispatchEvent(new Event("filter:changed"))
    })
    .catch(function (err) {
      console.error(err);
    });
  }
}

// component that applies filters
class FilterApply extends HTMLElement{
  connectedCallback(){
    this.addEventListener('click', (e) => {
      e.preventDefault();
      console.log("dispatch filter:apply")
      window.dispatchEvent(new Event('filter:apply'));
      this.update()
    })
    window.addEventListener('filter:changed', this.update.bind(this))
    window.addEventListener('filter:init', this.update.bind(this))
  }
  update(){
    // if(FilterValue.virtualUrl == location.href){
    //   this.setAttribute('disabled', 'disabled')
    // }
    // else{
    //   this.removeAttribute('disabled')
    // }
  }
}
customElements.define("filter-apply", FilterApply);


class FilterReset extends HTMLElement{
  connectedCallback(){
    this.addEventListener('click', (e) => {
      e.preventDefault();
      console.log("dispatch filter:reset")
      window.dispatchEvent(new Event('filter:reset'));
      this.update()
    })
    window.addEventListener('filter:changed', this.update.bind(this))
    window.addEventListener('filter:init', this.update.bind(this))
  }
  update(){
    // const baseUrl = new URL(location.pathname)
    // if(FilterValue.virtualUrl == baseUrl.href){
    //   this.setAttribute('disabled', 'disabled')
    // }
    // else{
    //   this.removeAttribute('disabled')
    // }
  }
}
customElements.define("filter-reset", FilterReset);

class FilterValuePriceRange extends FilterValue {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback()
    this.updateUrl = this.getAttribute("update-url");
    this.fromSlider = this.querySelector("#fromRange");
    this.toSlider = this.querySelector("#toRange");
    this.fromInput = this.querySelector("#fromValue");
    this.toInput = this.querySelector("#toValue");
    // check if component is valid
    if(!this.updateUrl || !this.fromSlider || !this.toSlider || !this.fromInput || !this.toInput){
      return
    }
    this.fillSlider(this.fromSlider, this.toSlider, "rgba(25,10,0, 0.15)", "var(--color-primary, #000)", this.toSlider);
    this.setToggleAccessible(this.toSlider);
    this.fromSlider.addEventListener("input", this.controlFromSlider.bind(this));
    this.toSlider.addEventListener("input", this.controlToSlider.bind(this));
    this.fromInput.addEventListener("input", this.controlFromInput.bind(this));
    this.toInput.addEventListener("input", this.controlToInput.bind(this));
    this.fromSlider.addEventListener("input", this.debounce(this.handleInput.bind(this), 500));
    this.toSlider.addEventListener("input", this.debounce(this.handleInput.bind(this), 500));
    this.fromInput.addEventListener("input", this.debounce(this.handleInput.bind(this), 500));
    this.toInput.addEventListener("input", this.debounce(this.handleInput.bind(this), 500));
  }
  debounce(fn, wait) {
    const that = this;
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(that, args), wait);
    };
  }
  handleInput() {
    const that = this;
    let url = that.updateUrl;
    const range_min = 0;
    const range_max = Number(that.toInput.max) ? Number(that.toInput.max) : 1000000;
    const min = that.fromInput.value;
    const max = that.toInput.value;
    if (url.includes("?")) {
      if (!!min && min > range_min) {
        url += `&filter.v.price.gte=${min}`;
      }
    } else {
      if (!!min && min > range_min) {
        url += `?filter.v.price.gte=${that.fromInput.value}`;
      }
    }
    if (url.includes("?")) {
      if (!!max && max < range_max) {
        url += `&filter.v.price.lte=${max}`;
      }
    } else {
      if (!!max && max < range_max) {
        url += `?filter.v.price.lte=${max}`;
      }
    }
    super.updateDOM(url);
  }
  controlFromInput() {
    const that = this;
    const [from, to] = that.getParsed(that.fromInput, that.toInput);
    that.fillSlider(that.fromInput, that.toInput, "rgba(25,10,0, 0.15)", "var(--color-primary, #000)", that.toSlider);
    if (from > to) {
      that.fromSlider.value = to;
      that.fromInput.value = to;
    } else {
      that.fromSlider.value = from;
    }
  }
  controlToInput() {
    const that = this;
    const [from, to] = that.getParsed(that.fromInput, that.toInput);
    that.fillSlider(that.fromInput, that.toInput, "rgba(25,10,0, 0.15)", "var(--color-primary, #000)", that.toSlider);
    that.setToggleAccessible(that.toInput);
    if (from <= to) {
      that.toSlider.value = to;
      that.toInput.value = to;
    } else {
      that.toInput.value = from;
    }
  }
  controlFromSlider() {
    const that = this;
    const [from, to] = that.getParsed(that.fromSlider, that.toSlider);
    that.fillSlider(that.fromSlider, that.toSlider, "rgba(25,10,0, 0.15)", "var(--color-primary, #000)", that.toSlider);
    if (from > to) {
      that.fromSlider.value = to;
      that.fromInput.value = to;
    } else {
      that.fromInput.value = from;
    }
  }
  controlToSlider() {
    const that = this;
    const [from, to] = that.getParsed(that.fromSlider, that.toSlider);
    that.fillSlider(that.fromSlider, that.toSlider, "rgba(25,10,0, 0.15)", "var(--color-primary, #000)", that.toSlider);
    that.setToggleAccessible(that.toSlider);
    if (from <= to) {
      that.toSlider.value = to;
      that.toInput.value = to;
    } else {
      that.toInput.value = from;
      that.toSlider.value = from;
    }
  }
  getParsed(currentFrom, currentTo) {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
  }
  fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    const rangeDistance = to.max - to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
  }
  setToggleAccessible(currentTarget) {
    const that = this;
    const toSlider = that.querySelector("#toRange");
    if (Number(currentTarget.value) <= 0) {
      toSlider.style.zIndex = 2;
    } else {
      toSlider.style.zIndex = 0;
    }
  }
}
customElements.define("filter-value-price-range", FilterValuePriceRange);

class FilterValueBoolean extends FilterValue {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback()
    this.addEventListener("click", () => {
      const url = this.getAttribute("update-url");
      if (!!url) {
        super.updateDOM(url);
      }
    });
  }
}
customElements.define("filter-value-boolean", FilterValueBoolean);

class FilterValueList extends FilterValue {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback()
    this.addEventListener("click", () => {
      const url = this.getAttribute("update-url");
      if (!!url) {
        super.updateDOM(url);
      }
    });
  }
}
customElements.define("filter-value-list", FilterValueList);

class FilterValueRemove extends FilterValue {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback()
    this.addEventListener("click", () => {
      const url = this.getAttribute("update-url");
      if (!!url) {
        super.updateDOM(url);
      }
    });
  }
}
customElements.define("filter-value-remove", FilterValueRemove);

class FilterValueType extends FilterValue {
  constructor() {
    super();
  }
  updateDeepLinking(url) {
    const currentURL = new URL(location.href);
    const newURL = new URL(url, location.origin);
    // übernehme alle parameter die nichts mit dem filter zu tun haben
    currentURL.searchParams.forEach((value, key) => {
      if (!key.includes("type")) {
        newURL.searchParams.set(key, value);
      }
      if(key.includes("filter")) {
        newURL.searchParams.delete(key);
      }
    });
    history.replaceState(null, "", newURL.href);
  }
  connectedCallback() {
    super.connectedCallback()
    const that = this;
    this.addEventListener("click", () => {
      const type = that.getAttribute("update-type");
      const currentURL = new URL(location.href);
      const newUrl = new URL(location.href);
      currentURL.searchParams.forEach((value, key) => {
        if(key.includes("filter")) {
          newUrl.searchParams.delete(key);
        }
      });
      newUrl.searchParams.set('type', type);
      const url = newUrl.pathname+newUrl.search;
      super.updateDOM(url);
    });
  }
}
customElements.define("filter-value-type", FilterValueType);

class Collapsible extends HTMLElement {
  static formAssociated = true;
  constructor() {
    super();
  }
  connectedCallback() {
    this.transitionDuration = this.getAttribute("transition-duration") || 300;
    this.content = this.querySelector("collapsible-content");
    this.label = this.querySelector("collapsible-label");
    window.addEventListener('resize', this.setHeight.bind(this))
    if (this.isOpen()) {
      if(this.content){
        this.content.style.position = "static";
      }
      this.style.height = "auto";
      requestAnimationFrame(() => {
        this.setHeight();
      });
    }
    if(this.label){
      this.label.addEventListener("click", (e) => {
        this.toggle();
      });
    }
  }
  isOpen() {
    return this.hasAttribute("open");
  }
  setInitialHeight() {
    if(this.label){
      const labelHeight = this.label.getBoundingClientRect().height;
      this.style.height = labelHeight + "px";
    }

  }
  setHeight() {
    if(this.content && this.label){
      const contentHeight = this.content.getBoundingClientRect().height;
      const labelHeight = this.label.getBoundingClientRect().height;
      this.style.height = contentHeight + labelHeight + "px";
    }
  }
  open() {
    this.setAttribute("open", true);
    this.setInitialHeight();
    this.setHeight();

    setTimeout(() => {
      if(this.content){
        this.content.style.position = "static";
      }
      this.style.height = "auto";
      this.style.overflow = "";
      this.dispatchEvent(new Event("collapsible:opened"));
    }, this.transitionDuration);
  }
  close() {
    this.removeAttribute("open");
    this.setHeight();
    this.style.overflow = "hidden";
    window.requestAnimationFrame(() => {
      if(this.content){
        this.content.style.position = "";
      }
      this.setInitialHeight();
      this.dispatchEvent(new Event("collapsible:closed"));
    });
  }
  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }
}
customElements.define("collapsible-outer", Collapsible);
customElements.define("collapsible-content", class extends HTMLElement {});
customElements.define("collapsible-label", class extends HTMLElement {});

class Dropdown extends HTMLElement {
  static formAssociated = true;
  constructor() {
    super();
  }
  connectedCallback() {
    this.transitionDuration = this.getAttribute("transition-duration") || 300;
    this.content = this.querySelector("dropdown-content");
    this.label = this.querySelector("dropdown-label");
    if(this.label){
      this.label.addEventListener("click", (e) => {
        this.toggle();
      });
    }
    document.body.addEventListener('click', this.detectOutsideClick.bind(this))
  }
  detectOutsideClick(e){
    if(!this.contains(e.target)){
      this.close()
    }
  }
  disconnectedCallback(){
    document.body.removeEventListener('click', this.detectOutsideClick.bind(this))
  }
  isOpen() {
    return this.hasAttribute("open");
  }
  open() {
    this.setAttribute("open", true);

  }
  close() {
    this.removeAttribute("open");
  }
  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }
}
customElements.define("dropdown-outer", Dropdown);
customElements.define("dropdown-content", class extends HTMLElement {});
customElements.define("dropdown-label", class extends HTMLElement {});

class FilterValueDateRange extends FilterValue {
  constructor() {
    super();
  }
  get css(){
    const css = this.getAttribute('css') || ""
    if(css.includes(',')){
      return css.split(',').map(c => c.trim())
    }
    return [css]
  }
  get format(){
    return this.getAttribute('format') || ""
  }
  get placeholder(){
    return this.getAttribute('placeholder') || ""
  }
  get value(){
    return this.getAttribute('value') || ""
  }
  set value(newValue){
    this.setAttribute('value', newValue)
    this.dispatchEvent(new Event('change'))
  }
  get filterValues(){
    return (this.getAttribute('filter-values') || "").split(',').map(t => Number(t.trim()))
  }
  get start(){
    return this.getAttribute('start') || ""
  }
  get end(){
    return this.getAttribute('end') || ""
  }
  get locale(){
    return this.getAttribute('locale') || "en"
  }
  connectedCallback() {
    super.connectedCallback()
    this.shadow = this.attachShadow({ mode: "open" });
    this.shadow.innerHTML = `
      <input part="input" placeholder="${this.placeholder}"/>
      <svg part="icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M320-400q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm160 0q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm160 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/></svg>
    `
    this.input = this.shadow.querySelector('input')

    this.picker = new easepick.create({
      element: this.input,
      css: this.css,
      zIndex: 10,
      calendars: 2,
      grid: 2,
      lang: this.locale,
      format: this.format,
      readonly: false,
      plugins: [
        "RangePlugin",
        "AmpPlugin",
      ],
      AmpPlugin: {
        dropdown: {
          months: true,
          years: true,
        },
        resetButton: true,
        darkMode: false
      },
    })
    if(!!this.start){
      this.picker.setStartDate(this.start)
    }
    if(!!this.end){
      this.picker.setEndDate(this.end)
    }

    this.picker.on('view', (evt) => {
      const { view, date, target } = evt.detail;
      const d = date ? date.format('YYYY-MM-DD') : null;
      const DateTime = easepick.DateTime;
      const allowedDates = this.filterValues?.map(t => new DateTime(t, 'YYYY-MM-DD').format('YYYY-MM-DD'))

      if (view === 'CalendarDay') {
        const div = target.querySelector('.event-dot') || document.createElement('div');
        div.className = `event-dot ${allowedDates?.includes(d) ? "" : "placeholder"}`;

        target.append(div);
      }
    });
    this.picker.renderAll()
    this.picker.on('select', (e) => {
      const startDate = new Date(Date.parse(this.picker.getStartDate()));
      const endDate = new Date(Date.parse(this.picker.getEndDate()));
      endDate.setHours(23,59,59,999);
      const start = Date.parse(startDate)
      const end = Date.parse(endDate)
      const filterValuesInRange = this.filterValues.filter(t => t >= start && t <= end)
      this.value = `${filterValuesInRange.join(',')}`
    })
    this.picker.on('clear', () => {
      this.value = ""
    })

    this.addEventListener("change", () => {
      const url = new URL(location);
      if(this.paramName){
        url.searchParams.delete(this.paramName)
        this.value.split(',').forEach(t => {
          url.searchParams.append(this.paramName, t)
        })
      }
      if (!!url) {
        super.updateDOM(url);
      }
    });

  }
}
customElements.define("filter-value-date-range", FilterValueDateRange);

function haversineDistance(lat1, lon1, lat2, lon2) {
  // Convert degrees to radians
  lat1 = (lat1 * Math.PI) / 180;
  lon1 = (lon1 * Math.PI) / 180;
  lat2 = (lat2 * Math.PI) / 180;
  lon2 = (lon2 * Math.PI) / 180;

  // Haversine formula  
  const dLat = lat2 - lat1;
  const dLon = lon2 - lon1;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  // Earth's radius in kilometers
  const R = 6371;

  return R * c;
}

const LOCATIONS_DB_NAME = 'LocationLookup'
const LOCATIONS_TABLE_NAME = 'locations'

class FilterValueLocation extends FilterValue {
  constructor() {
    super();
  }
  get placeholder(){
    return this.getAttribute('placeholder') || ""
  }
  get helptext(){
    return this.getAttribute('helptext') || ""
  }
  get value(){
    return this.getAttribute('value') || ""
  }
  get locale(){
    return this.getAttribute('locale') || "en-US"
  }
  get language(){
    return this.locale.split('-').at(0) || "en"
  }
  get src(){
    return this.getAttribute('src') || ""
  }
  set value(newValue){
    this.setAttribute('value', newValue)
    if(!!this.input){
      this.input.value = newValue
    }
    window.sessionStorage.setItem('_filterLocationValue', newValue)
    this.dispatchEvent(new Event('change'))
    this.updateIcon();
  }
  set lat(newValue){
    this.setAttribute('lat', newValue)
    window.sessionStorage.setItem('_filterLocationLat', newValue)
  }
  set lon(newValue){
    this.setAttribute('lon', newValue)
    window.sessionStorage.setItem('_filterLocationLon', newValue)
  }
  get lat(){
    return this.getAttribute('lat') || ""
  }
  get lon(){
    return this.getAttribute('lon') || ""
  }
  get filterValues(){
    return (this.getAttribute('filter-values') || "").split(',').filter(f => !!f).map(t => t.trim())
  }
  async downloadSource(){
    return await fetch(this.src)
    .then(res => res.text())
    .catch(console.error)
  }
  connectedCallback() {
    super.connectedCallback()

    const openRequest = window.indexedDB.open(LOCATIONS_DB_NAME, 3);

    openRequest.onupgradeneeded = async (event) => {
      switch(event.oldVersion) { // existing db version
        case 0: // no db -> continue with case 1

        case 1: // old db version -> continue with case 2

        case 2:
          const db = event.target.result
          if (!db?.objectStoreNames.contains(LOCATIONS_TABLE_NAME)) {
            // create object stre when not existing
            db.createObjectStore("locations", {keyPath: 'id'});
            // create indices
            const store = event.target.transaction.objectStore(LOCATIONS_TABLE_NAME)
            store.createIndex("NameIndex", "name");
            store.createIndex("ZipIndex", "zip");
          }

          await new Promise((resolve) => {
            event.target.transaction.oncomplete = resolve
          })

          // get csv data
          const csv = await this.downloadSource()
          const lines = csv.split('\n').filter(l => !!l).map(l => l.split(';').map(c => c.trim()))

          const transaction = db?.transaction(LOCATIONS_TABLE_NAME, 'readwrite');
          const store = transaction?.objectStore(LOCATIONS_TABLE_NAME);
          if(store){
            store.clear();
          }

          // populate db
          lines.forEach(([country, zip, name, lat, lon], index) => {
            const entry = {
              id: index,
              country,
              zip,
              name: String(name).toLowerCase().replace(/\"/g, ""),
              displayName: String(name).replace(/\"/g, ""),
              lat: Number(lat),
              lon: Number(lon)
            }
            store.add(entry)
          });

          await new Promise((resolve) => {
            transaction.oncomplete = resolve
          })
        case 3:
          console.log("Database up to date.")
          this.filterValuesEntries = null
          return
      }
    };

    openRequest.onerror = () => {
      console.error("Error", openRequest.error);
    };

    openRequest.onsuccess = async (event) => {
      this.db = event.target.result
      this.lat = window.sessionStorage.getItem('_filterLocationLat') || ""
      this.lon = window.sessionStorage.getItem('_filterLocationLon') || ""
      this.value = window.sessionStorage.getItem('_filterLocationValue') || ""

    };

    this.shadow = this.attachShadow({ mode: "open" });
    this.shadow.innerHTML = `
      <style>
        @keyframes spin{
          from {
            rotate: 0deg;
          }
          to {
            rotate: 360deg;
          }
        }
        [part="localize-button"]{
          color: #000;
        }
        [part="localize-button"][loading] {
          color: #fff;
        }
        [part="localize-button"][loading]:before {
            --spinner-size: 14px;
            --spinner-thickness: 2px;
            --spinner-offset: calc(calc(var(--spinner-size) + calc(2* var(--spinner-thickness))) / -2);
            content: "";
            margin-left: var(--spinner-offset);
            margin-top: var(--spinner-offset);
            width: var(--spinner-size);
            height: var(--spinner-size);
            opacity: 1;
            border-color: #000;
            transform-origin: 50%;
            border-style: solid;
            border-top-color: #0000;
            border-width: var(--spinner-thickness);
            border-radius: 50%;
            animation: 1s linear infinite spin;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
        }
        [part="suggestions"]:not(:empty){
          border: 1px solid rgba(60, 64, 67, .2);
          border-top: none;
        }
          [part="outer-input-wrapper"] {
          display: flex; 
          flex-direction: row;
          position: relative;
          width: 100%;
          }
          [reset-input] {
            cursor: pointer;
            display: flex;
            position: absolute;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            right: 10px;
            top: 0;
            height: 100%;
          }
      </style>
      <div part="wrapper">
      <div part="outer-input-wrapper">
        <div part="input-wrapper">
          <input part="input" placeholder="${this.placeholder}"/>
          <div part="suggestions"></div>
        </div>
          <div class="close" reset-input>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="18px" width="18px" version="1.1" viewBox="0 0 460.775 460.775" xml:space="preserve">
              <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
            </svg>
          </div>
          </div>
        <button part="localize-button">
          <svg part="localize-button-found" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M440-42v-80q-125-14-214.5-103.5T122-440H42v-80h80q14-125 103.5-214.5T440-838v-80h80v80q125 14 214.5 103.5T838-520h80v80h-80q-14 125-103.5 214.5T520-122v80h-80Zm40-158q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-120q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T560-480q0-33-23.5-56.5T480-560q-33 0-56.5 23.5T400-480q0 33 23.5 56.5T480-400Zm0-80Z"/></svg>
          <svg part="localize-button-search" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M440-40v-80q-125-14-214.5-103.5T122-438H42v-80h80q14-125 103.5-214.5T440-836v-80h80v80q125 14 214.5 103.5T838-518h80v80h-80q-14 125-103.5 214.5T520-120v80h-80Zm40-158q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Z"/></svg>
        </button>
      </div>
      <p part="helptext">${this.helptext}</p>
    `
    this.updateIcon();
    this.input = this.shadow.querySelector('input')
    this.suggestions = this.shadow.querySelector('[part="suggestions"]')
    this.localizeButton = this.shadow.querySelector('[part="localize-button"]')
    this.resetInput = this.shadow.querySelector('[reset-input]')

    this.localizeButton.addEventListener('click', async () => {
      this.localizeButton.setAttribute('loading', 'loading')
      await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject)
      })
      .then(res => {
        this.lat = Number(res.coords.latitude)
        this.lon = Number(res.coords.longitude)
        this.input.value = "Dein Standort"
        this.input.dispatchEvent(new Event('change'))
        this.localizeButton.removeAttribute('loading')
        console.log(res)
      })
      .catch(error => {
        this.lat = ""
        this.lon = ""
        this.input.value = ""
        this.input.dispatchEvent(new Event('change'))
        window.alert(error.message)
        this.localizeButton.setAttribute('disabled', 'disabled')
        this.localizeButton.removeAttribute('loading')
      })
    })

    // this.addEventListener("change", async (e) => {
    //   console.log(e)
    //   this.updateSort();
    // });

    window.addEventListener('filter:apply', this.updateSort.bind(this))
    window.addEventListener('filter:reset', this.updateSort.bind(this))
    window.addEventListener('filter:sort-by', this.sortListener.bind(this))

    this.input.addEventListener("blur", async () => {
      this.input.value = this.value
    });
    this.input.addEventListener("focus", async () => {
      this.input.value = ""
    });

    this.input.addEventListener("change", async () => {
      this.value = this.input.value
    });

    this.resetInput.addEventListener("click", () => {
      this.value = "";
      this.input.value = "";
      window.dispatchEvent(new Event('filter:reset'))
    })

    this.input.addEventListener("input", async (e) => {
      const q = e.target.value.toLowerCase()
      if(!q){
        return window.dispatchEvent(new Event('filter:reset'));
      }
      const results = await this.searchLocationByNameOrZip(q)

      if(!results || results.length == 0){
        return this.clearSuggestions()
      }

      this.updateSuggestions(results)

    })

    document.body.addEventListener('click', this.detectOutsideClick.bind(this))

    this.sortProductsByDate()
  }
  updateIcon(){
    if(this.value == "Dein Standort"){
      this.shadow.querySelector('[part="localize-button-search"]').style.display = "none"
      this.shadow.querySelector('[part="localize-button-found"]').style.display = ""
    }
    else{
      this.shadow.querySelector('[part="localize-button-search"]').style.display = ""
      this.shadow.querySelector('[part="localize-button-found"]').style.display = "none"
    }
  }
  detectOutsideClick(e){
    if(!this.contains(e.target)){
      this.dispatchEvent(new Event('blur'))
    }
  }
  disconnectedCallback(){
    document.body.removeEventListener('click', this.detectOutsideClick.bind(this))
  }
  clearSuggestions(){
    this.suggestions.innerHTML = ``
  }

  updateSort(){
    if(!this.value || this.value === ""){
      this.value = ""
      this.lat = ""
      this.lon = ""
      document.querySelector('[sort-by] input[value="location"]').disabled = true
    } else {
      this.sortProductsByDistance()
      document.querySelector('[sort-by] input[value="location"]').disabled = false
      document.querySelector('[sort-by] input[value="location"]').checked = true
    }
  }

  sortListener(event) {
    if (event?.detail == "location")
      this.sortProductsByDistance()
    if (event?.detail == "date")
      this.sortProductsByDate()
  }

  updateSuggestions(results){
    const entriesSortedByName = results.sort((a, b) => a.name.localeCompare(b.name, this.locale, { numeric: true }))
    const uniqueEntriesSortedByName = Array.from(new Set(entriesSortedByName.map(a => a.displayName)))
    .map(displayName => {
      return entriesSortedByName.find(a => a.displayName === displayName)
    })
    this.suggestions.innerHTML = `
      <ul part="suggestion-list">
        ${uniqueEntriesSortedByName.slice(0, 10).map(r =>
          `<li 
          part="suggestion-list-entry"
          data-lat="${r.lat}"
          data-lon="${r.lon}"
          >${r.displayName} (${r.country})</li>`).join('')
        }
      </ul>
    `
    this.suggestions.querySelectorAll('li').forEach(li => {
      li.addEventListener('click', () => {
        this.lat = Number(li.dataset.lat)
        this.lon = Number(li.dataset.lon)
        this.input.value = li.innerHTML
        this.value = li.innerHTML
        this.suggestions.innerHTML = ``
        this.blur()
      })
    })
  }
  unsortProductsByDistance(){
    document.querySelectorAll(`[data-zip]`).forEach(element => {
      //element.style.order = ""
      element.querySelectorAll('[data-km]').forEach((el) => {
        el.innerHTML = ``
        el.parentElement.classList.add('hidden')
      })
    })
  }
  async sortProductsByDistance(){
    if(!this.filterValuesEntries){
      const transaction = this.db?.transaction(LOCATIONS_TABLE_NAME, 'readwrite')
      const store = transaction?.objectStore(LOCATIONS_TABLE_NAME);
      const index = store.index('ZipIndex');
      this.filterValuesEntries = await Promise.all(this.filterValues.map((zip) => {
        return new Promise((resolve) => {
          const request = index.get(zip)
          request.onsuccess = (e) => resolve(e.target.result)
        })
      }))
    }

    document.querySelectorAll(`[data-zip]`).forEach((element) => {
      const entry = this.filterValuesEntries?.filter(e => !!e).find(({zip}) => zip == element.dataset.zip)

      if(!entry){
        element.style.order = 9999
        return;
      }

      const distance = haversineDistance(this.lat, this.lon, entry.lat, entry.lon)
      element.style.order = String(Math.round(distance));

      element.querySelectorAll('[data-km]').forEach((el) => {
        el.innerHTML = `${String(Math.round(distance))}`
        el.parentElement.classList.remove('hidden')
        el.closest('.ticket-card__text').classList.remove('hidden')
      })
    })
  }
  async sortProductsByDate(){
    const sorted_elements = Array.from(document.querySelectorAll('[data-date]'));

    // Sort the elements based on the `data-date` attribute (assumed to be a timestamp)
    sorted_elements.sort((a, b) => {
      const dateA = new Date(a.getAttribute('data-date'))
      const dateB = new Date(b.getAttribute('data-date'))

      if ( dateA < dateB ) return -1
      if ( dateA > dateB ) return +1
      return 0
    });
    // Re-sort with CSS order
    sorted_elements.forEach((element, index)=> element.style.order = index);
  }

  async searchLocationByNameOrZip(q){
    const transaction = this.db?.transaction(LOCATIONS_TABLE_NAME, 'readwrite');
    const store = transaction?.objectStore(LOCATIONS_TABLE_NAME)
    const results = []

    const zipCursor = store?.index("ZipIndex").openCursor(IDBKeyRange.bound(q, q + "\uffff"));
    if(zipCursor){
      zipCursor.onsuccess = function (event) {
        const cursor = event.target.result;
        if (cursor) {
          results.push(cursor.value)
          cursor.continue();
        }
      };
    }


    const nameCursor = store?.index("NameIndex").openCursor(IDBKeyRange.bound(q, q + "\uffff"));
    if(nameCursor){
      nameCursor.onsuccess = function (event) {
        const cursor = event.target.result;
        if (cursor) {
          results.push(cursor.value)
          cursor.continue();
        }
      };
    }

    await new Promise((resolve) => {
      if(transaction){
        transaction.oncomplete = resolve
      }
    })

    return results
  }
}
customElements.define("filter-value-location", FilterValueLocation);

class ShowInterest extends HTMLElement{
  constructor() {
    super();
  }
  connectedCallback() {
    const configScript = document.getElementById('config-data');
    if (!!configScript) {
      const jsonString = configScript.textContent.trim();
      
      const config = JSON.parse(jsonString);

      const start = config.min;
      const end = config.max;
      const interestNumber = this.getRandomIntInclusive(start, end);

      this.innerHTML = interestNumber
    }
  }
  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
customElements.define("show-interest", ShowInterest);